<template>
  <div id="contenedor-reporte-liquidacion">
    <v-list dense subheader>
      <v-subheader
        v-if="mostrarTitulo">
        LIQUIDACION
      </v-subheader>
      <v-list-item v-if="mostrarDetalleEstimadoOpf" link>
        <v-list-item-content>
          <v-list-item-title>
            COSTO DIRECTO
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          {{ estimacion.importeCostoDirecto | currency }}
        </v-list-item-action>
      </v-list-item>
      <v-list-item v-if="mostrarDetalleEstimadoOpf" link>
        <v-list-item-content>
          <v-list-item-title>
            INDIRECTOS ({{contrato.porcentajeCostoIndirectos}}%)
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          {{ estimacion.importeCostoIndirectos | currency }}
        </v-list-item-action>
      </v-list-item>
      <v-list-item v-if="mostrarDetalleEstimadoOpf" link>
        <v-list-item-content>
          <v-list-item-title>
            UTILIDAD ({{contrato.porcentajeUtilidad}}%)
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          {{ estimacion.importeUtilidad | currency }}
        </v-list-item-action>
      </v-list-item>
      <v-list-item v-if="mostrarDetalleEstimadoOpf" link>
        <v-list-item-content>
          <v-list-item-title>
            ADICIONALES ({{contrato.porcentajeCargosAdicionales}}%)
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          {{ estimacion.importeCargosAdicionales | currency }}
        </v-list-item-action>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item link>
        <v-list-item-content>
          <v-list-item-title>
            IMPORTE ESTIMACIÓN
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          {{ estimacion.importeEstimado | currency }}
        </v-list-item-action>
      </v-list-item>
      <!-- <v-list-item link>
        <v-list-item-content>
          <v-list-item-title>NETO</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          {{ estimacion.importeNeto | currency }}
        </v-list-item-action>
      </v-list-item> -->
      <v-list-item v-if="mostrarDetallesDeducciones" link>
        <v-list-item-content>
          <v-list-item-title>AMORTIZACIÓN ANTICIPO</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          {{ estimacion.importeAmortizacionAnticipo | currency }}
        </v-list-item-action>
      </v-list-item>
      <v-divider v-if="mostrarDetallesControlEstimacion"></v-divider>
      <v-list-item v-if="mostrarDetallesControlEstimacion" link>
        <v-list-item-content>
          <v-list-item-title>SUBTOTAL</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          {{ estimacion.subtotal | currency }}
        </v-list-item-action>
      </v-list-item>
      <v-list-item v-if="esObraFinanciada && mostrarDetallesControlEstimacion" link>
        <v-list-item-content>
          <v-list-item-title>
            COSTO FINANCIERO ({{estimacion.porcentajeCostoFinanciero}}%)
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          {{ estimacion.importeCostoFinanciero | currency }}
        </v-list-item-action>
      </v-list-item>
      <v-divider v-if="esObraFinanciada && mostrarDetallesControlEstimacion"></v-divider>
      <v-list-item v-if="esObraFinanciada && mostrarDetallesControlEstimacion" link>
        <v-list-item-content>
          <v-list-item-title>SUBTOTAL 2</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          {{ estimacion.subtotalDos | currency }}
        </v-list-item-action>
      </v-list-item>
      <v-list-item v-if="mostrarDetallesControlEstimacion" link>
        <v-list-item-content>
          <v-list-item-title>
            {{ (estimacion.porcentajeIva) }}% I.V.A
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          {{ estimacion.importeIva | currency }}
        </v-list-item-action>
      </v-list-item>
      <v-divider v-if="mostrarDetallesControlEstimacion"></v-divider>
      <v-list-item v-if="mostrarDetallesControlEstimacion" link>
        <v-list-item-content>
          <v-list-item-title>FACTURADO</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          {{ estimacion.totalFactura | currency }}
        </v-list-item-action>
      </v-list-item>
      <template
        v-if="mostrarDetallesDeducciones">
        <v-subheader>DEDUCCIONES</v-subheader>
        <v-divider></v-divider>
        <template v-for="(deduccion) in estimacion.deducciones">
          <v-list-item :key="deduccion.deduccion.id" link>
            <v-list-item-content>
              <v-list-item-title>
                {{ deduccion.deduccion.nombre }} ({{deduccion.deduccion.porcentaje}}%)
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              {{ deduccion.importe | currency }}</v-list-item-action>
          </v-list-item>
        </template>
      </template>
      <template
        v-else-if="mostrarDetallesControlEstimacion">
        <v-list-item link>
          <v-list-item-content>
            <v-list-item-title>
              TOTAL DEDUCCIONES
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            {{ estimacion.importeDeducciones | currency }}
          </v-list-item-action>
        </v-list-item>
      </template>
      <v-list-item v-if="mostrarDetallesDeducciones" link>
        <v-list-item-content>
          <v-list-item-title>RETENIDO</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          {{ estimacion.importeRetenido | currency }}
        </v-list-item-action>
      </v-list-item>
      <v-list-item v-if="mostrarDetallesDeducciones" link>
        <v-list-item-content>
          <v-list-item-title>DEVUELTO</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          {{ estimacion.importeDevuelto | currency }}
        </v-list-item-action>
      </v-list-item>
      <v-list-item v-if="mostrarDetallesDeducciones" link>
        <v-list-item-content>
          <v-list-item-title>SANCIÓN</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          {{ estimacion.importeSancion | currency }}
        </v-list-item-action>
      </v-list-item>
      <v-list-item v-if="mostrarDetallesDeducciones" link>
        <v-list-item-content>
          <v-list-item-title>AJUSTE</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          {{ estimacion.importeBonificacion | currency }}
        </v-list-item-action>
      </v-list-item>
      <v-divider v-if="mostrarDetallesDeducciones"></v-divider>
      <v-list-item v-if="mostrarDetallesDeducciones" link>
        <v-list-item-content>
          <v-list-item-title>LÍQUIDO</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          {{ estimacion.importeLiquido | currency }}
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
export default {
  name: 'EstimacionReporteLiquidacion',
  props: {
    estimacion: {
      type: Object,
      required: true,
    },
    mostrarTitulo: {
      type: Boolean,
      required: false,
      default: true,
    },
    mostrarDetallesDeducciones: {
      type: Boolean,
      required: false,
      default: false,
    },
    esObraFinanciada: {
      type: Boolean,
      required: true,
    },
    contrato: {
      type: Object,
      required: false,
    },
    mostrarDetalleEstimadoOpf: {
      type: Boolean,
      required: false,
      default: false,
    },
    mostrarDetallesControlEstimacion: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
